<template>
  <div class="image-container">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>